import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from '@shared/modules';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { ThankYouLoginPageComponent } from '@shared/components';
import { registerLocaleData } from '@angular/common';
import {
    NgcCookieConsentModule,
    NgcCookieConsentConfig,
} from 'ngx-cookieconsent';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';

import localeEs from '@angular/common/locales/es';

// Thirdparty Imports
import { provideEnvironmentNgxMask, IConfig } from 'ngx-mask';
const maskConfig: Partial<IConfig> = {
    validation: false,
};

const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: window.location.hostname,
    },
    palette: {
        popup: {
            background: '#000',
        },
        button: {
            background: '#f1d600',
        },
    },
    theme: 'classic',
    type: 'info',
    content: {
        message:
            'Vemo utiliza cookies propias y de terceros que permiten mejorar la usabilidad de navegación y recopilar información. No se utilizarán las cookies para recoger información de carácter personal. Solo se instalarán las cookies no esenciales para la navegación si acepta esta característica.',
        link: '',
        dismiss: 'Aceptar',
        deny: 'Rechazar',
    },
};

registerLocaleData(localeEs);

@NgModule({
    declarations: [AppComponent, ThankYouLoginPageComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MaterialModule,
        HttpClientModule,
        NgcCookieConsentModule.forRoot(cookieConfig),
    ],
    providers: [
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'es-AR',
        },
        { provide: LOCALE_ID, useValue: 'es' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideEnvironmentNgxMask(maskConfig),
        JwtHelperService,
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
